/*
===============================================================================================================
                                 Copyright 2025-2026, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import getEnvVar from './environment-variable';

export const isStaticBuildEnabled = () => getEnvVar('NEXT_PUBLIC_STATIC_BUILD_ENABLED') === 'true';

export const isStaticApiEnabled = () => getEnvVar('REACT_APP_STATIC_BUILD_API_ENABLED')?.toLowerCase() === 'true';

// returns the CDN url base path for the static build mode, in the normal mode it's not set
export const getStaticCdnPath = () => getEnvVar('NEXT_PUBLIC_CDN_BASE_PATH') || '';

export const getAppPathname = () => {
  if (typeof window !== 'undefined') {
    return window.location.pathname.split(getStaticCdnPath())?.[1] || '';
  }
  return '';
};

export const getAppInsightsKey = () => getEnvVar('NEXT_PUBLIC_APP_INSIGHTS_KEY') || '';

export default {
  isStaticBuildEnabled,
  isStaticApiEnabled,
  getStaticCdnPath,
  getAppPathname,
  getAppInsightsKey,
};
